import styled from "styled-components";

export const HypothesisName = styled.h1`
  margin-top: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
`;
